// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7a85fcbe","327":"76bd6ba1","498":"e3443fe2","524":"88f664eb","560":"a7a7ecad","703":"88e801a2","787":"cda6f2bd"}[chunkId] + ".chunk.js";
};